export default "<a [class]=\"'link _cancel ' + fromSize(size)\" [class._disabled]=\"disabled\">\n    <ng-content></ng-content>\n</a>\n";